import { render, staticRenderFns } from "./CookingCheckIndexPreview.vue?vue&type=template&id=0a2fbb22&"
import script from "./CookingCheckIndexPreview.vue?vue&type=script&lang=js&"
export * from "./CookingCheckIndexPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports